import React, { useEffect, useRef, useState } from "react";
import { Get } from "../../../../actions";
import { Card, CardContent, Typography, Grid, Box, List, ListItem, ListItemText, Dialog, DialogTitle, Button, DialogContent, DialogContentText, DialogActions, Slide } from "@material-ui/core";
import { getTableAtPosition } from "../../../common/tablePlacement/component/getTableAtPosition";
import AlertDialog from "../../../../components/DeleteDialog";
import { CancelButton, ConfirmButton } from "../../../../components/ButttonsWithIcons";
import { getTranslation } from "../../../../heplers/translationHelper";
import { AreaList } from "../../../common/tablePlacement/AreaList";
import TableCanvas from "../../../common/tablePlacement/TableCanvas";

export const TableSelection = ({ formdata, onTableSelected, onAreaSelected }) => {
    const [selectedArea, setSelectedArea] = useState(null);
    const canvasRef = useRef(null);

    
  const [areas, setAreas] = useState([]);
    
    useEffect(() => {
      fetchAreas();
    }, []);
    const fetchAreas = async () => {
      try {
        await Get(
          {},
          "TableManagement/GetAllAreas",
          null,
          (response) => {
            setAreas(response.data);
            if(response.data.length && !selectedArea)
              {
                setSelectedArea(response.data[0])
                onAreaSelected(response.data[0])
            }
            // const initialTables = {};
            // response.data.forEach((area) => {
            //   initialTables[area.id] = [];
            // });
            // setTables(initialTables);
          },
          (error) => {
            console.error("Error fetching areas:", error);
          }
        );
      } catch (error) {
        console.error("Error fetching areas:", error);
      }
    };

    return (
      <Box sx={{ padding: 3 }}>
        {/* <Typography variant="h5" sx={{ marginBottom: 2, fontWeight: "bold" }}>
         
          {getTranslation("Available Table Areas",
                " Available Table Areas",
                " Available Table Areas")}
        </Typography>
        <Grid container spacing={3} sx={{ marginTop: 2 }}>
          <Grid item xs={12} md={4}>
            <AreaList
              areas={areas}
              onAreaChange={(newArea) => {
                setSelectedArea(newArea)
                onAreaSelected(newArea)
            }}
              selectedArea={selectedArea}
            />
          </Grid>
        
        </Grid> */}

     
      </Box>
    );
};

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="down" ref={ref} {...props} />;
});